// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__AyKZR","loaderOuter":"PageOverlayLoader_loaderOuter__GHOGU"};